// extracted by mini-css-extract-plugin
export default {"container":"fhDCp3","label":"p05vFA","content":"mllAwQ","no-label":"vxb_uP"};